import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function Office() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [branches, setBranches] = useState([])

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit Office` : 'Add Office'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get office
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/office/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setOfficeData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create office
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/office`, {
                ...officeData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit office
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/office/${id}`, {
                ...officeData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [officeData, setOfficeData] = useState<any>(type === 'edit' ? [] :
        {
            "branch": null,
            "partner": null,
            "officename": null,
            "officeaddress": null,
            "phone": null,
            "latitude": null,
            "longitude": null,
            "deptcode": null
        }
    )

    //Get partners for Select field
    async function getBranches(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/branch`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setBranches(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }



    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'edit' && fetchData()
        getBranches()
        console.log(officeData);

    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 600, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField sx={{ width: 600 }} error={officeData.officename === null} onChange={(e) => setOfficeData({ ...officeData, officename: e.target.value !== '' ? e.target.value : null })} value={officeData.officename || ''} variant="outlined" size="small" label={<TranslatedText text={'Office name'} />} />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Branch name'} />*</InputLabel>
                        <Select sx={{ width: 600 }} labelId="simple-select-label" onChange={(e) => setOfficeData({ ...officeData, branch: e.target.value !== "" ? e.target.value : null })} value={officeData.branch || ''} variant="outlined" size="small" label={<><TranslatedText text={'Branch name'} />*</>} >
                            <MenuItem value={''}><TranslatedText text={'Not selected'} /></MenuItem>
                            {
                                branches.map((el: any) => {
                                    return (
                                        accesslevel === "5" ? <MenuItem key={el.id} value={el.id}>{el.partnerbankcode + " - " + el.branchname}</MenuItem> :
                                            <MenuItem key={el.id} value={el.id}>{el.branchname}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <TextField sx={{ width: 600 }} onChange={(e) => setOfficeData({ ...officeData, officeaddress: e.target.value !== '' ? e.target.value : null })} value={officeData.officeaddress || ''} variant="outlined" size="small" label={<TranslatedText text={'Office address'} />} />
                    <TextField sx={{ width: 600 }} onChange={(e) => setOfficeData({ ...officeData, phone: e.target.value !== '' ? e.target.value : null })} value={officeData.phone || ''} variant="outlined" size="small" label={<TranslatedText text={'Phone'} />} />
                    <TextField sx={{ width: 600 }} onChange={(e) => setOfficeData({ ...officeData, latitude: e.target.value !== '' ? e.target.value : null })} value={officeData.latitude || ''} variant="outlined" size="small" label={<TranslatedText text={'Latitude'} />} />
                    <TextField sx={{ width: 600 }} onChange={(e) => setOfficeData({ ...officeData, longitude: e.target.value !== '' ? e.target.value : null })} value={officeData.longitude || ''} variant="outlined" size="small" label={<TranslatedText text={'Longitude'} />} />
                    <TextField sx={{ width: 600 }} onChange={(e) => setOfficeData({ ...officeData, deptcode: e.target.value !== '' ? e.target.value : null })} value={officeData.deptcode || ''} variant="outlined" size="small" label={<TranslatedText text={'Dept code'} />} />
                </Box>
                <Button onClick={() => type === "edit" ? putData(officeData) : postData(officeData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/offices' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}